import { render, staticRenderFns } from "./gridResults.vue?vue&type=template&id=99c1dba8&scoped=true&"
import script from "./gridResults.vue?vue&type=script&lang=js&"
export * from "./gridResults.vue?vue&type=script&lang=js&"
import style0 from "./gridResults.vue?vue&type=style&index=0&id=99c1dba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c1dba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/ruliland/Downloads/Proyectos/vola/coworking/frontend_coworking/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {VTextField})
